module.exports = __webpack_public_path__ + "img/ft-crop.8e3dfa50.svg";